import React from "react"
import About from "../../../pages/About";
import BugReporting from "../../../pages/BugReporting";
import CreateBudget from "../../../pages/CreateBudget";
import Homepage from "../../../pages/Homepage";

export const ROUTES = [
    {
        path:"/budget",
        page: <CreateBudget/>
    },
    {
        path:"/report",
        page: <BugReporting/>
    },
    {
        path:"/about",
        page: <About/>
    },
    {
        path:"/",
        page: <Homepage/>
    },
]